import { render, staticRenderFns } from "./ButtonsFilters.vue?vue&type=template&id=1be4bb4b&scoped=true&lang=pug"
import script from "./ButtonsFilters.vue?vue&type=script&lang=js"
export * from "./ButtonsFilters.vue?vue&type=script&lang=js"
import style0 from "./ButtonsFilters.vue?vue&type=style&index=0&id=1be4bb4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4bb4b",
  null
  
)

export default component.exports